import * as AccordionPrimitive from '@radix-ui/react-accordion';
import type { ComponentRef, Ref } from 'react';

import { AccordionProvider } from '../AccordionContext';
import type { AccordionRootProps } from '../types';

/**
 * Accordion component.
 *
 * @component
 * @example
 * ```tsx
 * <Accordion>
 *  <AccordionTrigger
 *    title="Section 1"
 *  />
 *  <AccordionContent>Content 1</AccordionContent>
 * </Accordion>
 * ```
 */
export const Accordion = ({
  children,
  ref,
  grouped,
  scrollIntoViewOnOpen,
  ...props
}: AccordionRootProps & {
  ref?: Ref<ComponentRef<typeof AccordionPrimitive.Root>>;
}) => {
  return (
    // scrollIntoViewOnOpen is consumed via context (by AccordionContent) and
    // must not be spread onto the DOM element.
    <AccordionPrimitive.Root ref={ref} {...props}>
      <AccordionProvider value={{ ...props, grouped, scrollIntoViewOnOpen }}>
        {children}
      </AccordionProvider>
    </AccordionPrimitive.Root>
  );
};

Accordion.displayName = AccordionPrimitive.Root.displayName;
